// extracted by mini-css-extract-plugin
module.exports = {"buttons":"discountCode_buttons__56dd_","container":"discountCode_container__1uOjQ","title":"discountCode_title__z3kaq","subtitle":"discountCode_subtitle__mNdN5"};